module.exports = __webpack_public_path__ + "img/check.27161d52.svg";